// @ts-nocheck
// Tiny hook that resolves to true once we've confirmed the current user
// has is_admin = true. Rolls a single rpc call; null while loading so
// callers can render a spinner instead of flashing the wrong UI.

import { useEffect, useState } from "react";
import { supabase } from "./supabase";
import { useAuth } from "./useAuth";

export function useAdmin() {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (authLoading) return;
    if (!user) {
      setIsAdmin(false);
      return;
    }
    (async () => {
      const { data, error } = await supabase.rpc("is_current_user_admin");
      if (cancelled) return;
      setIsAdmin(error ? false : !!data);
    })();
    return () => {
      cancelled = true;
    };
  }, [user, authLoading]);

  return { isAdmin, loading: authLoading || isAdmin === null };
}
